
import axios from "axios";
import check from "~/store/elementChecker";

let lock = false;
let dataMethod = async ({
  app,
  req,
  route,
  commit,
  store,
  redirect,
  silent,
}) => {
  let host = "";
  if (process.server) {
    host = req.headers.host + route.fullPath;
  } else {
    host = location.host + route.fullPath;
  }
  let page = 1,
    pages = 0,
    limit = 16,
    total = 0,
    pagination = [],
    items = [],
    filters = {
      business_activity: "",
      manufacturer: "",
      family: "",
      subfamily: "",
      category: "",
      q: "",
      limit: 16,
      page: 1,
      pages: 1,
      sorting: {},
    };
  let params = {};
  let occupied = [];
  let path = (route.params.path || "").split("/");
  path.forEach((p, index) => {
    if (p.includes("m.")) {
      params.manufacturer = p.replace("m.", "");
      occupied.push(index);
    } else if (p.includes("ba.")) {
      params.business_activity = p.replace("ba.", "");
      occupied.push(index);
    } else if (p.includes("fa.")) {
      params.family = p.replace("fa.", "");
      occupied.push(index);
    } else if (p.includes("sf.")) {
      params.subfamily = p.replace("sf.", "");
      occupied.push(index);
    } else if (p.includes("ca.")) {
      params.category = p.replace("ca.", "");
      occupied.push(index);
    }
    if (!occupied.includes(index) && !params.business_activity) {
      params.business_activity = p;
    } else if (!occupied.includes(index) && !params.family) {
      params.family = p;
    } else if (!occupied.includes(index) && !params.subfamily) {
      params.subfamily = p;
    } else if (!occupied.includes(index) && !params.category) {
      params.category = p;
    } else if (!occupied.includes(index) && !params.manufacturer) {
      params.manufacturer = p;
    }
  });
  let combined_params = { ...params, ...route.query };
  store.commit("params", params);
  let search = [];
  if (
    !combined_params.orderby &&
    !combined_params.q &&
    store.state.store.eshop.sorting[0]
  ) {
    let sorting = store.state.store.eshop.sorting[0] || {};
    filters.sorting = sorting;
    filters.orderby = ((sorting.value || "").split("+") || {})
      .filter((x) => x)[0]
      .split("=")[1];
    filters.order = ((sorting.value || "").split("+") || {})
      .filter((x) => x)[1]
      .split("=")[1];
    combined_params.orderby = ((sorting.value || "").split("+") || {})
      .filter((x) => x)[0]
      .split("=")[1];
    combined_params.order = ((sorting.value || "").split("+") || {})
      .filter((x) => x)[1]
      .split("=")[1];
  }
  Object.keys(combined_params)
    .filter((k) => combined_params[k] != "-" && combined_params[k])
    .forEach((k) => {
      if (combined_params[k] && combined_params[k] != "-") {
        let cp = combined_params[k];

        if (Array.isArray(cp)) {
          cp = [...new Set(cp)].join(",");
        }
        k = encodeURIComponent(k);
        search.push(`${k}=${encodeURIComponent(cp)}`);
      }
    });
  search = search.filter((x) => x).join("&");
  store.commit("sidePanel", {});

  if (
    (store.getters.store.eshop || {}).limit &&
    !(search + "").includes("limit")
  ) {
    filters.limit = store.getters.store.eshop.limit;
    search += `&limit=${filters.limit}`;
  }
  // if(store.getters.store.eshop.searchReplicate){
  //   search += `&fields=${store.getters.store.eshop.searchReplicate}`
  // }

  try {
    let temp = await axios.get(
      `${process.env.axiosUrl}/items/sv/store/${store.state.store.store_id}?store_id=${store.state.store.store_id}&fullProductPath=${store.state.store.eshop.fullProductPath}&catalogRoute=${store.state.store.eshop.catalogRoute}&${search}`,
      {
        headers: {
          shopster: host,
          Authorization: `Bearer ${store.state.token}`,
        },
      }
    );
    temp = (temp || {}).data;
    if (temp) {
      items = await app.$hyperItem.prepareItems(
        ((temp || {}).items || []).docs || []
      );

      filters.page = temp.items.page;
      filters.pages = temp.items.pages;
      filters.total = temp.items.total;
      if (store.state.filters.sorting) {
        filters.sorting = store.state.filters.sorting;
      }
      let full_combined = { ...filters, ...params, ...route.query };
      if (full_combined.orderby) {
        full_combined.sorting =
          store.state.store.eshop.sorting.find(
            (s) =>
              s.value.includes(full_combined.orderby) &&
              s.value.includes(full_combined.order)
          ) || "";
      } else {
        full_combined.sorting = {};
      }
      for (const k of [
        "business_activity",
        "family",
        "manufacturer",
        "subfamily",
        "category",
      ]) {
        if (full_combined[k]) {
          let proper = items.find((i) => i[`${k}_slug`] == full_combined[k]);
          if (proper) {
            full_combined[k] = proper[k];
            full_combined[`${k}_slug`] = proper[`${k}_slug`];
          }
        }
      }
      Object.keys(full_combined)
        .filter(
          (k) =>
            ![
              "business_activity",
              "family",
              "manufacturer",
              "subfamily",
              "category",
              "page",
              "limit",
              "orderby",
              "order",
              "pages",
            ].includes(k) || k.includes("tag.")
        )
        .forEach((k) => {
          (full_combined[k] + "").split("_or_").forEach((v) => {
            let proper = items.find((i) =>
              i.tags.find(
                (t) => t.key_slug == k.replace("tag.", "") && t.value_slug == v
              )
            );
            if (proper) {
              let tag = proper.tags.find(
                (t) => t.key_slug == k.replace("tag.", "") && t.value_slug == v
              );
              if (tag) {
                store.commit("filterLabels", {
                  key: k.replace("tag.", ""),
                  value: tag.key,
                });
                store.commit("filterLabels", {
                  key: tag.value_slug,
                  value: tag.value,
                });
                // full_combined[`tag.${tag.key}`] = tag.value;
                // full_combined[`${k}_slug`] = tag.value_slug;
                // delete full_combined[k];
              }
            }
          });
        });
      store.commit("filters", full_combined);
      await store.dispatch("filters");
      pagination = [];
      for (let i = 1; i <= temp.items.pages; i++) {
        if (i == 1) {
          pagination.push(i);
        }
        if (
          i > temp.items.page - 5 &&
          i < temp.items.page + 5 &&
          i > 1 &&
          i < temp.items.pages
        ) {
          pagination.push(i);
        }
        if (i == temp.items.pages) {
          pagination.push(i);
        }
      }
      pagination = [...new Set(pagination)];
    }

    store.commit("pagination", pagination);
    store.commit("items", items);
  } catch (error) {
    console.error(error);
  }
  let preview = "";
  if (app.$cookies.get("preview")) {
    let pr = (app.$cookies.get("preview") || "").split(":::");
    if (pr[1] == store.getters.store.id) {
      preview = `&preview=${pr[0]}`;
    }
  }
  try {
    let res = await axios.post(
      `${process.env.axiosUrl}/stores/${store.getters.store.id}/elements`,
      {
        build: (store.getters.store.build || {}).build_no,
        elements: "search",
        condition: store.getters.filters,
      }
    );
    if ((res.data || {}).id) {
      store.commit("elements", [
        ...store.getters.store.eshop.elements.filter((e) => e.static),
        ...res.data.eshop.elements,
      ]);
      let es = JSON.parse(JSON.stringify(store.getters.store));

      es.eshop.elements =
        (await app.$hyperElement.populateData({ page: "search", app })) || [];
      store.commit("store", es);
    }
  } catch (e) {
    console.error(e);
  }
  let property = "";
  if (filters.subfamily) {
    property = "subfamily";
  } else if (filters.family) {
    property = "family";
  } else {
    property = "business_activity";
  }
  //CMS META INFO
  try {
    app.$cms.get({
      title: "categories",
      store_id: store.getters.store.id,
      limit: 1000,
      property,
      q: store.getters.filters[property],
    });
  } catch (error) {}

  lock = false;
  store.commit("sub", {
    page,
    pages,
    limit,
    total,
    search,
  });
};
const titleCreator = (store, queries, params) => {
  let keys = [
    "q",
    "manufacturer",
    "tags",
    "category",
    "subfamily",
    "family",
    "business_activity",
    "persons",
  ];
  let all = { ...queries, ...params };
  return (
    Object.keys(all)
      .filter((k) => k.includes("tag."))
      .reduce((acc, k) => {
        if (all[k] && all[k] != "-") {
          let vs = all[k].split("_or_");
          vs.forEach((v) => {
            if (store.getters.filterLabels[v]) {
              acc.push(`${store.getters.filterLabels[v]}`);
            }
          });
        }
        return acc;
      }, [])
      .join(", ") +
    keys.reduce((acc, k) => {
      if (k == "tags" && all[k] && all[k] != "-") {
        acc += `${all[k]
          .split("_or_")
          .map((a) => (a.split(" | ") || [])[0])
          .join(" ")} `;
        return acc;
      }
      if (all[k] && all[k] != "-") {
        acc += `${all[k].replace("_or_", ", ")} `;
      }
      return acc;
    }, "") +
    " - " +
    ((store.getters.store || {}).eshop || {}).name
  );
};
export default {
  mounted() {
    this.analysis();
  },
  watch: {
    "$route.query": {
      handler(v) {
        if (lock) {
          return;
        }
        lock = true;
        if (this.$route.name == "catalog-map") {
          dataMethod({
            app: $nuxt,
            route: this.$route,
            commit: this.$store.commit,
            store: this.$store,
            redirect: (status, url) => {
              if (process.browser) {
                location.href = url;
              }
            },
          });
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      head: {
        title: titleCreator(
          this.$store,
          this.$route.query,
          this.$store.getters.params
        ),
        meta: [
          ...this.$hyperSeo.meta({
            description: `${
              this.$store.getters.sideFilters.business_activity || ""
            } ${this.$store.getters.sideFilters.family || ""} ${
              this.$store.getters.sideFilters.subfamily || ""
            } ${this.$store.getters.sideFilters.category || ""}`,
          }),
          ...this.$hyperSeo.og({
            "og:description": `${
              this.$store.getters.sideFilters.business_activity || ""
            } ${this.$store.getters.sideFilters.family || ""} ${
              this.$store.getters.sideFilters.subfamily || ""
            } ${this.$store.getters.sideFilters.category || ""}`,
          }),
        ],
      },
    };
  },
  methods: {
    analysis() {
      if (!(this.item || {}).barcode && !this.failed) {
        setTimeout(() => {
          this.$nuxt.$emit("informant:view_item_list", {
            list_name: titleCreator(
              this.$store,
              this.$route.query,
              this.$route.params
            ),
            items: this.$store.getters.items,
          });
        }, 1000);
      } else if ((this.item || {}).barcode) {
        setTimeout(() => {
          this.$nuxt.$emit("informant:view_item", {
            item: this.item,
          });
        }, 1000);
      }
    },
  },
  async asyncData({ app, req, route, commit, store, redirect }) {
    await new Promise((resolve) => setTimeout(resolve, 20));
    if (store.getters.isBackButton) {
      store.commit("isBackButton", false);
      return {};
    }
    let preview = "";
    if (app.$cookies.get("preview")) {
      let pr = (app.$cookies.get("preview") || "").split(":::");
      if (pr[1] == store.getters.store.id) {
        preview = `&preview=${pr[0]}`;
      }
    }
    check(
      store.getters.store.id,
      route,
      app,
      preview,
      (store.getters.store.build || {}).build_no
    );
    return dataMethod({ app, req, route, commit, store, redirect });
  },
  head() {
    let title, description;
    let fromCms = this.$store.getters.cms.categories;
    try {
      fromCms = fromCms.find(
        (f) =>
          f.business_activity ==
            this.$store.getters.filters.business_activity &&
          (f.family || "") == (this.$store.getters.filters.family || "") &&
          (f.subfamily || "") == (this.$store.getters.filters.subfamily || "")
      );
      title = fromCms.title;
      description = fromCms.description;
    } catch (error) {
      title = titleCreator(this.$store, this.$store.getters.filters, {});
      description = `${this.$store.getters.filters.business_activity || ""} ${
        this.$store.getters.filters.family || ""
      } ${this.$store.getters.filters.subfamily || ""} ${
        this.$store.getters.filters.category || ""
      }`;
    }
    return {
      title,
      meta: [
        ...this.$hyperSeo.meta({
          description,
        }),
        ...this.$hyperSeo.og({
          "og:title": title,
          "og:description": description,
        }),
      ],
      script: [
        this.$hyperSeo.ld("breadcrumb"),
        {
          hid: "ldBreadcrumb",
          type: "application/ld+json",
          json: this.$hyperSeo.schemas(
            "breadcrumbFilters",
            this.$store.getters.filters
          ),
        },
        {
          hid: "ldBreadcrumb",
          type: "application/ld+json",
          json: this.$hyperSeo.schemas("itemList", this.$store.getters.items),
        },
      ],
    };
  },
};
